import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[addMenu]',
    standalone: true,
})
export class MenuDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
